export default function ErrorPage() {
  return (
    <div className="flex fixed inset-0 flex-col justify-center items-center px-6">
      <div className="max-w-md text-center">
        <h1 className="text-5xl font-bold text-red-500 dark:text-red-400">
          Something went wrong
        </h1>
        <p className="mt-4 text-lg text-muted-foreground">
          We encountered an error while processing your request.
        </p>
      </div>
    </div>
  )
}
